var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isBackground)?_c('div',{staticClass:"lazy",attrs:{"data-bg":_vm.loadSrc}},[_vm._t("default")],2):_c('img',{staticClass:"lazy",attrs:{"data-src":_vm.loadSrc}})}
var staticRenderFns = []

export { render, staticRenderFns }